import { defineComponent as _defineComponent } from 'vue'
import { Event } from '@/models/Event';
import { stripHtml } from '@/helpers/tools';


export default /*#__PURE__*/_defineComponent({
  __name: 'list-item-title',
  props: {
    item: {
        type: Event,
        required: true,
    },
},
  setup(__props) {



return { __sfc: true,stripHtml }
}

})